import {Button} from 'shells/button/button';

import {appHistory} from '../../../history';

export function SchedulerTitleBarButton() {
    return (
        <Button
            variant='primary'
            size='big'
            onClick={() => {
                appHistory.push('/sales/scheduler?create=true');
            }}
        >
            + Create new meeting
        </Button>
    );
}
